<template>
  <div id="app">
    <ThePage needDownload />
    <RegistrationUrlTracker />
    <Registration :showHeading="true" />
  </div>
</template>

<script>
import ThePage from "@/components/the-page/vue/ThePage.vue";
import RegistrationUrlTracker from "@godweb/frontend-base/src/components/registrationurltracker/RegistrationUrlTracker";
import Registration from "@godweb/frontend-base/src/components/register/mygames/ProjectReg";

export default {
  name: "App",
  components: {
    ThePage,
    Registration,
    RegistrationUrlTracker,
  },
};
</script>
